import {
  PROJECT_DETAILS_ACTION,
  CREATE_PROJECT_ACTION,
  DECLARE_MONTHLY_ISSUE_ACTION
} from "../constant";
import request from "../services/requestService";
import * as apiServices from "../services/apiServices";
import moment from "moment";
import { sortBy, maxBy } from "lodash";

export const getProjectDetails = (requestMethod = request, projectDetails) => {
  return function(dispatch) {
    dispatch({
      type: PROJECT_DETAILS_ACTION.PROJECT_DETAILS_START
    });
    return requestMethod(apiServices.getProjectDetails(projectDetails))
      .then(projectDetails => {
        const payload = projectDetails.data;
        dispatch({
          type: PROJECT_DETAILS_ACTION.PROJECT_DETAILS_SUCCESS,
          payload
        });
        return payload;
      })
      .catch(() => {
        dispatch({
          type: PROJECT_DETAILS_ACTION.PROJECT_DETAILS_FAILURE
        });
      });
  };
};

export const changeProjectStatus = (requestMethod = request, params) => {
  return requestMethod(apiServices.changeProjectStatusParams(params))
    .then(response => {
      return response;
    })
    .catch(e => {
      console.log("change Project Status Failed", e.message);
    });
};

export const getProjectUpdates = (requestMethod = request, params) => {
  return requestMethod(apiServices.getProjectUpdates(params))
    .then(response => {
      return response;
    })
    .catch(e => {
      console.log("Error while geeting updates", e.message);
    });
};

export const getProjectComments = (requestMethod = request, params) => {
  return requestMethod(apiServices.getProjectComments(params))
    .then(response => {
      return response;
    })
    .catch(e => {
      console.log("Error while geeting comments", e.message);
    });
};

export const getProjectNoteAction = (requestMethod = request, params) => {
  return requestMethod(apiServices.getProjectNote(params))
    .then(response => response)
    .catch(console.error);
};

export const saveProjectNoteAction = (requestMethod = request, params) => {
  return requestMethod(apiServices.saveProjectNote(params))
    .then(response => response)
    .catch(console.error);
};

export const saveProjectCommentAction = (params, requestMethod = request) => {
  return requestMethod(apiServices._saveProjectComment(params))
    .then(response => response)
    .catch(console.error);
};

export const getDraftedProjectDetails = (requestMethod = request) => {
  return function(dispatch) {
    dispatch({
      type: PROJECT_DETAILS_ACTION.DRAFTED_PROJECT_DETAILS_START
    });
    return requestMethod(apiServices._getDraftedProjectDetails())
      .then(projectDetails => {
        const payload = projectDetails.data;
        dispatch({
          type: PROJECT_DETAILS_ACTION.DRAFTED_PROJECT_DETAILS_SUCCESS,
          payload
        });
        return payload;
      })
      .catch(() => {
        dispatch({
          type: PROJECT_DETAILS_ACTION.DRAFTED_PROJECT_DETAILS_FAILURE
        });
      });
  };
};

export const _updateDraftedMilestones = params => {
  return function(dispatch) {
    dispatch({
      type: CREATE_PROJECT_ACTION.DRAFT_NEW_MILESTONE,
      payload: params
    });
  };
};

const getColorForDates = projectTimelineData => {
  let revisedTargetCompletionDate =
    projectTimelineData.revisedTargetCompletionDate;
  let anticipatedCompletionDate = projectTimelineData.anticipatedCompletionDate;
  let commissionedDate = projectTimelineData.commissionedDate;
  let currentDate = moment().format("x");

  let revisedDateColor = "#000000";
  let anticipatedDateColor = "#000000";

  if (revisedTargetCompletionDate === null) {
    if (anticipatedCompletionDate !== null) {
      if (commissionedDate === null) {
        //check with current date
        if (anticipatedCompletionDate > currentDate) {
          anticipatedDateColor = "#DB8700";
        } else if (anticipatedCompletionDate === currentDate) {
          anticipatedDateColor = "#000000";
        } else {
          anticipatedDateColor = "#FF2E2E";
        }
      }
    }
  } else {
    if (commissionedDate === null) {
      anticipatedDateColor = "#000000";
      //check with current date
      if (revisedTargetCompletionDate > currentDate) {
        revisedDateColor = "#DB8700";
      } else if (revisedTargetCompletionDate === currentDate) {
        revisedDateColor = "#000000";
      } else {
        revisedDateColor = "#FF2E2E";
      }
    }
  }

  return { revisedDateColor, anticipatedDateColor };
};

const setProjectTimelineData = projectTimelineData => {
  if (projectTimelineData && projectTimelineData.data) {
    let {
      issuesTimeline,
      underConstructionPercentage,
      partiallyCommissionedPercentage,
      pragatiDates
    } = projectTimelineData.data;

    let {
      revisedDateColor = "#000000",
      anticipatedDateColor = "#000000"
    } = getColorForDates(projectTimelineData.data);

    if (pragatiDates && pragatiDates.length) {
      pragatiDates.map((item, index) => {
        projectTimelineData.data[`pragatiReviewDate${index + 1}`] = item;
      });
    }

    let count = 0;
    let zeroLengthDates = 0;
    let total = 0;
    let unsortedArr =
      issuesTimeline && issuesTimeline.length
        ? issuesTimeline.map(item => {
            item.dates = [];
            item.colorForAnticipatedDate = anticipatedDateColor;
            item.colorForRevisedDate = revisedDateColor;
            item.underConstructionPercentage = underConstructionPercentage;
            item.partiallyCommissionedPercentage = partiallyCommissionedPercentage;
            Object.entries(projectTimelineData.data).forEach(([key, value]) => {
              if (
                key !== "issuesTimeline" &&
                key !== "pragatiDates" &&
                value !== null &&
                item.year === moment(value).year()
              ) {
                item.dates.push({ [key]: value, date: value });
                count++;
              }
            });

            if (item.dates.length === 0) {
              zeroLengthDates++;
            }
            return item;
          })
        : [];

    let arr = [];

    unsortedArr.map(item => {
      arr = [...arr, ...item.dates];
    });

    total = arr.length * 175 + zeroLengthDates * 200;

    let maxDatesYear = maxBy(unsortedArr, "dates.length");

    unsortedArr.map(item => {
      item.widthIsLess = !!(total < 1073);
      if (
        maxDatesYear &&
        (item.dates && item.dates.length) ===
          (maxDatesYear.dates && maxDatesYear.dates.length)
      ) {
        item.haveMaxDates = true;
      }
    });

    return sortBy(unsortedArr, ["year"]);
  }
};

export const getProjectTimelineData = (projectId, requestMethod = request) => {
  return function(dispatch) {
    dispatch({
      type: PROJECT_DETAILS_ACTION.PROJECT_TIMELINE_START
    });
    return requestMethod(apiServices._getProjectTimelineData(projectId))
      .then(projectDetails => {
        const payload = setProjectTimelineData(projectDetails.data);
        dispatch({
          type: PROJECT_DETAILS_ACTION.PROJECT_TIMELINE_SUCCESS,
          payload
        });
        return payload;
      })
      .catch(() => {
        dispatch({
          type: PROJECT_DETAILS_ACTION.PROJECT_TIMELINE_FAILURE
        });
      });
  };
};

export const getMilestoneGanttChartData = (
  projectID,
  requestMethod = request
) => {
  return function(dispatch) {
    dispatch({
      type: PROJECT_DETAILS_ACTION.PROJECT_MILESTONE_START
    });
    return requestMethod(apiServices._getMilestoneGanttChart(projectID))
      .then(resp => {
        const payload = resp.data;
        dispatch({
          type: PROJECT_DETAILS_ACTION.PROJECT_MILESTONE_SUCCESS,
          payload
        });
        return payload;
      })
      .catch(() => {
        dispatch({
          type: PROJECT_DETAILS_ACTION.PROJECT_MILESTONE_FAILURE
        });
      });
  };
};

export const getMeetingTypesDetails = (requestMethod = request) => {
  return function(dispatch) {
    dispatch({
      type: PROJECT_DETAILS_ACTION.PROJECT_MEETING_TYPES_START
    });
    return requestMethod(apiServices.getMeetingTypes())
      .then(meetingTypesDetails => {
        const payload = meetingTypesDetails.data;
        dispatch({
          type: PROJECT_DETAILS_ACTION.PROJECT_MEETING_TYPES_SUCCESS,
          payload
        });
        return payload;
      })
      .catch(() => {
        dispatch({
          type: PROJECT_DETAILS_ACTION.PROJECT_MEETING_TYPES_FAILURE
        });
      });
  };
};

export const getProjectDecisionDetailsAction = (
  requestMethod = request,
  project
) => {
  return function(dispatch) {
    dispatch({
      type: PROJECT_DETAILS_ACTION.PROJECT_DECISION_DETAILS_START
    });
    return requestMethod(apiServices.getProjectDecisionDetails(project.id))
      .then(projectDecisionDetails => {
        const payload = projectDecisionDetails.data;
        dispatch({
          type: PROJECT_DETAILS_ACTION.PROJECT_DECISION_DETAILS_SUCCESS,
          payload
        });
        return payload;
      })
      .catch(() => {
        dispatch({
          type: PROJECT_DETAILS_ACTION.PROJECT_DECISION_DETAILS_FAILURE
        });
      });
  };
};

export const declareMonthlyIssueAction = (
  requestMethod = request,
  data,
  id
) => {
  return function(dispatch) {
    dispatch({
      type: DECLARE_MONTHLY_ISSUE_ACTION.DECLARE_ISSUE_START
    });
    return requestMethod(apiServices.declareMonthlyIssue(data, id))
      .then(resp => {
        const data = resp;
        dispatch({
          type: DECLARE_MONTHLY_ISSUE_ACTION.DECLARE_ISSUE_SUCCESS
        });
        return {
          data: data
        };
      })
      .catch(() => {
        dispatch({
          type: DECLARE_MONTHLY_ISSUE_ACTION.DECLARE_ISSUE_FAILURE
        });
      });
  };
};
